import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Alert,
  Button,
  ButtonGroup,
  Chip,
  Grid,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import {
  getChips,
  ifError
} from '../../../helpers/panels/telechargeStatus/telechargeStatus';

import {
  panelsActive,
  panelsRemoveActive,
  panelsActiveItem,
  panelsRemoveActiveItemById
} from '../../../reducers/panels/panelsReducer';

import { PanelsOptionsMenu } from '../../../components/common/Options/PanelsOptionsMenu/PanelsOptionsMenu';

const DisplayResponseStatus = React.memo(({ result }) => {
  const panels = useSelector(state => state.panels.panels);
  const activePanels = useSelector(state => state.panels.active);
  const dispatch = useDispatch();

  let render = false;
  const summary = {
    allDevicesInvolved: [],
    successDevices: [],
    errorDevices: []
  };

  if (
    result?.result?.msg &&
    Array.isArray(result.result.msg) &&
    result.topic?.includes('status')
  ) {
    render = true;
    summary.allDevicesInvolved = panels.filter(e =>
      result.result.msg.find(item => item.ip === e.ip)
    );
    summary.successDevices = summary.allDevicesInvolved.filter(
      e => !ifError(result.result.msg.find(item => item.ip === e.ip)?.mascara)
    );
    summary.errorDevices = summary.allDevicesInvolved.filter(e =>
      ifError(result.result.msg.find(item => item.ip === e.ip)?.mascara)
    );
  }

  const handleSelect = (devices) => {
    dispatch(panelsRemoveActive());
    dispatch(panelsActive(devices.map(e => ({ id: e.id }))));
  };

  const toggleDevice = (deviceId) => {
    const isActive = activePanels.some(item => item.id === deviceId);
    if (isActive) {
      dispatch(panelsRemoveActiveItemById(deviceId));
    } else {
      dispatch(panelsActiveItem({ id: deviceId }));
    }
  };

  return (
    <>
      {render && (
        <Grid container>
          {(summary.successDevices.length > 0 || summary.errorDevices.length > 0) && (
            <Grid item xs={6}>
              <Typography variant="h4">
                Resultados ({summary.successDevices.length}/{summary.allDevicesInvolved.length})
              </Typography>
            </Grid>
          )}
          <Grid item xs={6}>
            <ButtonGroup>
              {summary.successDevices.length > 0 && (
                <Button onClick={() => handleSelect(summary.allDevicesInvolved)} sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>
                  Seleccionar equipos implicados
                </Button>
              )}
              {summary.successDevices.length > 0 && (
                <Button onClick={() => handleSelect(summary.successDevices)} sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>
                  Seleccionar equipos exitosos
                </Button>
              )}
              {summary.errorDevices.length > 0 && (
                <Button onClick={() => handleSelect(summary.errorDevices)} sx={{ backgroundColor: 'background.paper', color: 'text.primary' }}>
                  Seleccionar equipos no exitosos
                </Button>
              )}
            </ButtonGroup>
          </Grid>
          <Grid item xs={12} style={{ overflow: 'auto', maxHeight: 500 }}>
            {result.result.msg.map((e, i) => {
              const device = panels.find(item => item.ip === e.ip);
              if (!device) return null;

              const isActive = activePanels.some(item => item.id === device.id);

              return (
                <Alert
                  severity={ifError(e?.mascara) ? 'error' : 'success'}
                  key={i}
                  sx={{ mb: 1 }}
                >

                  {device.name}, {device.ip}: {e.result}{' '}
                  {getChips(e.mascara).map((chip, idx) => (
                    <Chip
                      key={`${i}-${idx}`}
                      size="small"
                      label={chip.name}
                      sx={{ ml: 1 }}
                      icon={<SystemUpdateAltIcon />}
                      disabled={!chip.status}
                    />
                  ))}
                  <Tooltip title={isActive ? `Deseleccionar ${device.name}` : `Seleccionar ${device.name}`}>
                    <IconButton
                      onClick={() => toggleDevice(device.id)}
                      sx={{ mr: 1 }}
                    >
                      {isActive ? <CheckCircleOutlineIcon /> : <RadioButtonUncheckedIcon />}
                    </IconButton>
                  </Tooltip>
                  <PanelsOptionsMenu id={device.id} />
                </Alert>
              );
            })}
          </Grid>
        </Grid>
      )}
    </>
  );
});

export default DisplayResponseStatus;
